import { ChooseButtonCheck } from '@jouzen/ecom-components/v3/ChooseButton';
import { Price } from '@jouzen/ecom-components/v3/Price';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import type WarrantySelection from '@/app/[locale]/product/_steps/enums/WarrantySelection';

const WarrantyContent = ({
  currencyCode,
  id,
  price,
  title,
  value,
}: {
  readonly currencyCode: string;
  readonly id: WarrantySelection;
  readonly price: number;
  readonly title: MessageKey;
  readonly value?: readonly string[];
}) => {
  const t = useTranslations();

  return (
    <div className="flex w-full items-center justify-between gap-2 text-gray-600">
      <div>
        <Typography variant="body-small" weight="black">
          {t(title)}
        </Typography>
        <Price price={price} currencyCode={currencyCode} />
      </div>
      <div className="flex justify-end">
        <ChooseButtonCheck
          chosen={value?.includes(id) ?? false}
          className={cx('size-5 transition-opacity')}
        />
      </div>
    </div>
  );
};

export default WarrantyContent;
